var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"main-button-wrapper",class:[
    _vm.type,
    _vm.size === 'sm' ? 'small' : '',
    _vm.invert ? 'inverted-colors' : '',
    _vm.disabled ? 'disabled' : ''
  ],attrs:{"type":"button","name":"main-button"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }